<template>
  <Teleport :to="target">
    <slot />
  </Teleport>
</template>

<script>
import { Teleport } from 'vue'

export default {
  name: 'SfPortal',
  components: {
    Teleport,
  },
  props: {
    target: {
      type: String,
      required: true,
    },
  },
}
</script>
